































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Task } from '@/types/Jobs'
import { completeTask } from '@/services/shifts'

@Component
export default class TaskList extends Vue {

  @Prop({ default: [] }) tasks!: Task[]

  loadingTask: number | null = null

  async completeTask(completed: boolean, taskId: number) {
    this.loadingTask = taskId
    try {
      await completeTask(this.$store, taskId, completed)
    }
    finally {
      this.loadingTask = null
    }
  }
}
